// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__XMgFW","empty":"ModalGraph_empty__iuHNg"};